import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "271",
  "slug": "spot-australia-from-satellite-imagery",
  "title": "How to Recognise Australia in Satellite Images",
  "excerpt": "The arid interior occupies much of a wide view of Australia.",
  "date": "2026-04-28",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/australia.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "The arid interior occupies much of a wide view of Australia. Greener land appears along parts of the east and southwest, with the Great Dividing Range near the eastern coast. The Gulf of Carpentaria cuts into the north; the Great Australian Bight forms a broad southern curve."
    },
    {
      "type": "heading",
      "text": "The interior and the settled coasts"
    },
    {
      "type": "paragraph",
      "text": "Compare the east coast with the interior at the same scale. Follow the change in vegetation rather than treating all of Australia as red desert."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Red or brown ground also occurs in southern Africa and the Americas. Circular irrigation fields are used around the world. A close view of either feature needs more evidence, such as the coastline or surrounding relief."
    }
  ],
  "imageAlt": "Australia regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
